import {ChangeDetectorRef, Component, Input, ViewChild} from "@angular/core";
import {Cohort} from "../../model/cohort";
import {TrialViewerComponent} from "../trial-viewer/trial-viewer.component";
import {ModelerPanelService} from "@ispm-client/modules/bpmn-modeler/service/modeler-panel.service";
import {PanelPosition} from "@ispm/layout/components/panel/panel.component";
import {
  AttachmentConfig,
  BpmnModelerConfig, CreationPanelConfig,
  NodeCreationPanelConfig
} from "@ispm-client/modules/bpmn-modeler/models/bpmn-modeler-config";
import {CurationActionCreatorService} from "../../../curation/services/curation-action-creator.service";
import {get} from "lodash";
import {NodeType} from "@ispm/shared/bpmn-io/node-type";
import {NodeCreationResult} from "@ispm-client/modules/bpmn-modeler/models/node-creation-result";
import {QueryNode} from "@ispm-client/modules/query-builder/models/query-builder-config";
import {ConditionFactorService} from "../../Services/condition-factor-service";
import {Subscription} from "rxjs";
import {SliderService} from "../../Services/slider-service";
import {Factor} from "../../model/factor";

@Component({
  selector: 'gen-trial-curation',
  templateUrl: './trial-curation.component.html',
  styleUrls: ['./trial-curation.component.scss']
})
export class TrialCurationComponent {
  @Input() trial: any;
  @Input() curationStatus: string;    // draft, waitforapproval, approved, rejected
  @ViewChild(TrialViewerComponent, {static: false}) trialViewer: TrialViewerComponent;

  private readonly QUERY = "query";
  panelName = ModelerPanelService.ModelerPanelName;
  panelPosition = PanelPosition.RIGHT;

  public formName: string;
  public bpmnModelerCfg: BpmnModelerConfig;
  private queryBuilderConfig: any;
  private data: any;
  private queryNode: QueryNode;
  private factor: Factor;
  sliderOpen: boolean = false;

  private querySubscription: Subscription;

  constructor(private modelerPanelService: ModelerPanelService,
              private changeDetector: ChangeDetectorRef, private curationActionCreatorService: CurationActionCreatorService,
              private conditionFactorService : ConditionFactorService, private sliderService: SliderService) {
  }

  ngOnInit() {
    this.querySubscription = this.sliderService.factor$
      .subscribe((factor: Factor) => {
        if (factor !== undefined) {
          this.editFactor(factor);
        }
      });

    this.setQueryBuilderConfig();
    this.data = {"id": this.QUERY, "name": this.QUERY, "ruleset": null};  //need to set title to enable save button
  }

  ngOnDestroy() {
    this.querySubscription.unsubscribe();
  }

  get editMode(): boolean {
    return this.curationStatus == 'draft';
  }

  selectTop() {
    if (this.trialViewer) {
      this.trialViewer.showTop();
    }
  }

  selectCohort(cohort: Cohort) {
    if (this.trialViewer) {
      this.trialViewer.showCohort(cohort);
    }
  }

  private setQueryBuilderConfig() {
    this.curationActionCreatorService.getState(['definitions'])
      .take(1)
      .subscribe((data => {
        let conf = Array.from(data.values()).filter(data => data['type'] === "clinical_trial")[0];
        this.formName = conf['ui']['forms']['editorForms']['formName'].name;
        this.bpmnModelerCfg = conf['ui']['bpmnModeler'];
        this.queryBuilderConfig = this.bpmnModelerCfg['panel']['nodeConfig']['nodeBuilder']['default']['queryBuilder'];
      }));
  }

  private editFactor(factor: Factor) {
    this.factor = factor;
    this.openNodeBuilder("Configure Condition");
  }

  private openNodeBuilder(label) {
    let element = this.getClosestParent(event.target, 'gen-condition-editor');
    if (element === null)
      return;

    const nodeBuilder: NodeCreationPanelConfig = get(this.bpmnModelerCfg.panel.nodeConfig.nodeBuilder, NodeType[NodeType.normal],
      get(this.bpmnModelerCfg.panel.nodeConfig.nodeBuilder, 'default', undefined));
    const attachmentConfig: AttachmentConfig = get(this.bpmnModelerCfg.panel.nodeConfig.nodeBuilder, 'attachmentConfig', undefined);
    const config: CreationPanelConfig = {nodeBuilder: nodeBuilder, attachmentConfig: attachmentConfig};
    config.nodeBuilder.label = label;

    this.data.ruleset = this.factor.queryNode;
    this.modelerPanelService.openNodeBuilder(config, this.data, false, this.onNodeUpdated.bind(this));
    this.sliderOpen = true;
  }

  onNodeUpdated(nodeCreationResult: NodeCreationResult) {
    this.sliderOpen = false;
    if (nodeCreationResult) {
      this.data = nodeCreationResult;
      this.factor.queryNode = nodeCreationResult.ruleset;
    }
    else {
      this.conditionFactorService.cancel(true);
    }
    this.conditionFactorService.update(true);
    this.modelerPanelService.closePanel();
  }

  private getClosestParent(elem, selector) {
    try {
      for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( elem.matches( selector ) )
          return elem;
      }
    }
    catch (err) {
      console.warn("getClosestParent couldn't find " + selector);
    }
    return null;
  }

}
